import { useApi } from '@backstage/core-plugin-api';
import CampaignIcon from '@mui/icons-material/Campaign';
import { SidebarItem } from '@traton/devportal-env-kit-app';
import { useEffect, useState } from 'react';
import { announcementApiRef } from '../../api/AnnouncementApi';

export const AnnouncementSidebarItem = () => {
  const api = useApi(announcementApiRef);
  const [canCreate, setCanCreate] = useState(false);

  useEffect(() => {
    api
      .checkPermissions()
      .then(perms => setCanCreate(perms.create))
      .catch(() => setCanCreate(false));
  }, [api]);

  if (!canCreate) return null;

  return (
    <SidebarItem
      icon={CampaignIcon}
      to="/announcement"
      text="Announcement"
      pluginId="announcement"
    />
  );
};
